$(document).ready(function () {
    var section = document.querySelector('.product-recommendations[data-url]');

    if (!section) return;

    fetch(section.dataset.url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
            var html = document.createElement('div');
            html.innerHTML = text;
            var recommendations = html.querySelector('.product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
                section.innerHTML = recommendations.innerHTML;

                var isRtl = document.body.classList.contains('rtl');

                $(section).find('.js-product-recommendations').slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                    infinite: false,
                    rtl: isRtl,
                    responsive: [{
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2
                        }
                    }]
                });
            }
        })
        .catch(function (e) {
            console.error(e);
        });
})